module.exports = __webpack_public_path__ + "img/Sugar4.518d197b.jpg";